import { useEffect, useRef } from 'react';

const activeBodyScrollLocks = new Set<string>();
let nextLockId = 0;

const getNextLockId = () => {
  nextLockId += 1;
  return `body-scroll-lock-${nextLockId}`;
};

const applyBodyScrollLockState = (body: HTMLElement) => {
  if (activeBodyScrollLocks.size > 0) {
    body.classList.add('is-scroll-locked');
  } else {
    body.classList.remove('is-scroll-locked');
  }
};

/**
 * Centralized body scroll lock with reference-count semantics.
 * Multiple overlays can lock concurrently; body unlocks only when all release.
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  const lockIdRef = useRef<string>(getNextLockId());

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const lockId = lockIdRef.current;
    const { body } = document;

    if (!isLocked) {
      return undefined;
    }

    activeBodyScrollLocks.add(lockId);
    applyBodyScrollLockState(body);

    return () => {
      activeBodyScrollLocks.delete(lockId);
      applyBodyScrollLockState(body);
    };
  }, [isLocked]);
};
